import { createFileRoute } from '@tanstack/react-router';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';
import { PROTECTED, SERVICE_CONTRACTS } from '@/lib/constants/routes';
import { ServiceContractCreate } from '@/pages/service-contracts/form/service-contract-create';

const RETURN_URL = `${PROTECTED}${SERVICE_CONTRACTS}`;

export const Route = createFileRoute(
  '/protected/_layout/service-contracts/_layout/new'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: () => <ServiceContractCreate returnUrl={RETURN_URL} />,
});
